import ContextAppIcon from './ContextAppIcon'
import ContextConnectButton from './ContextConnectButton'
import ContextConnectedButton from './ContextConnectedButton'
import { connectRowLabel } from './connectRowLabel'
import { useToolkitLogo } from './useToolkitLogo'
import rowStyles from './contextCardRow.module.scss'
import copyStyles from './contextCardCopy.module.scss'

export default function ConnectAppRow({ app, slug, reason, state, onClick, disabled }) {
  const iconSrc = useToolkitLogo(slug)
  return (
    <div className={rowStyles.row}>
      <ContextAppIcon src={iconSrc} alt={app ?? ''} />
      <p className={copyStyles.rowCopy}>
        <span className={copyStyles.lead}>Create a new connection to</span>
        {app ? <span className={copyStyles.app}>{app}</span> : null}
      </p>
      {state === 'connected' ? (
        <ContextConnectedButton />
      ) : (
        <ContextConnectButton disabled={disabled || state === 'working'} onClick={onClick}>
          {connectRowLabel(state, reason)}
        </ContextConnectButton>
      )}
    </div>
  )
}
